<script setup>

import TabItem from "@/components/tabs/TabItem.vue";
import TabContainer from "@/components/tabs/TabContainer.vue";
import {computed} from "vue";
import {useStore} from "vuex";
import {getBacklinkHealthcheck} from "@/composables/backlinks/useBacklinkHealthcheck";
import useHealthcheckStore from "@/composables/backlinks/useHealthcheckStore";

const store = useStore();

const pendingCount = computed(() => backlinksData.value?.pending?.length);
const keptCount = computed(() => backlinksData.value?.kept?.length);
const disavowedCount = computed(() => backlinksData.value?.disavowed?.length);

const { activeTab, maxDomainAuthority } = useHealthcheckStore();

const { data: backlinksData, isLoading } = getBacklinkHealthcheck(maxDomainAuthority);

const changeTab = (type) => {
  if (isLoading.value) {
    return;
  }

  store.dispatch('backlinkHealthcheck/setActiveTab', type)
}
</script>

<template>
  <TabContainer>
    <TabItem
      :active="activeTab === 'pending'"
      class="tw-flex tw-items-center tw-justify-center tw-space-x-3"
      :class="{
        'tw-pointer-events-none' : isLoading,
      }"
      @click="changeTab('pending')"
    >
      <svg-vue
        icon="icons/stop-watch"
        class="tw-w-6 tw-h-6"
        :class="{'tw-text-grey': activeTab === 'pending'}"
      />
      <span class="tw-font-bold">Pending</span>
      <span
        v-if="pendingCount !== undefined"
        class="tw-rounded-lg tw-w-6 tw-inline-block tw-py-1 tw-font-semibold tw-text-xs tw-bg-blue tw-text-white"
      >
        {{ pendingCount }}
      </span>
    </TabItem>

    <TabItem
      :active="activeTab === 'kept'"
      class="tw-flex tw-items-center tw-justify-center tw-space-x-3"
      :class="{
        'tw-pointer-events-none ' : isLoading,
      }"
      @click="changeTab('kept')"
    >
      <svg-vue
        icon="icons/link"
        class="tw-w-6 tw-h-6"
        :class="{'tw-text-grey': activeTab === 'kept'}"
      />
      <span class="tw-font-bold">Kept</span>
      <span
        v-if="keptCount !== undefined"
        class="tw-rounded-lg tw-w-6 tw-inline-block tw-py-1 tw-font-semibold tw-text-xs tw-bg-blue tw-text-white"
      >
        {{ keptCount }}
      </span>
    </TabItem>

    <TabItem
      :active="activeTab === 'disavowed'"
      class="tw-flex tw-items-center tw-justify-center tw-space-x-3"
      :class="{
        'tw-pointer-events-none ' : isLoading,
      }"
      @click="changeTab('disavowed')"
    >
      <svg-vue
        icon="icons/disavowed"
        class="tw-w-6 tw-h-6"
        :class="{'tw-text-grey': activeTab === 'disavowed'}"
      />
      <span class="tw-font-bold">Disavowed</span>
      <span
        v-if="disavowedCount !== undefined"
        class="tw-rounded-lg tw-w-6 tw-inline-block tw-py-1 tw-font-semibold tw-text-xs tw-bg-blue tw-text-white"
      >
        {{ disavowedCount }}
      </span>
    </TabItem>
  </TabContainer>
</template>
